
import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment, useRef } from 'react';
import {  XMarkIcon } from '@heroicons/react/24/outline';
function WatchYtVideo({ isOpen = false, onClose, title,ytvideo }) {
   // const { showToast } = useToast();
    const cancelButtonRef = useRef(null);

    return (
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={onClose}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-[554px] h-[417px] sm:w-[554px] sm:h-[417px] ">
                                <div className="bg-white px-4 lg:pb-2 pt-5 sm:p-6 sm:pb-4">
                                    <div className="w-full mb-2 items-center font-bold text-center sm:text-left">
                                        <Dialog.Title
                                            as="h3"
                                            className="text-[28px] font-bold leading-6 text-gray-900 text-center"
                                        >
                                            {/* {title} */}
                                        </Dialog.Title>
                                        <button
                                            type="button"
                                            className="absolute right-3 top-3 rounded-md bg-[#E5E5E5A3]  p-1 text-gray-500"
                                            onClick={onClose}
                                        >
                                            <span className="sr-only">
                                                Close
                                            </span>
                                            <XMarkIcon
                                                className="h-5 w-5 text-black"
                                                aria-hidden="true"
                                            />
                                        </button>
                                    </div>
                                </div>

                                <div className="bg-white px-4 pb-4 lg:pt-2 sm:p-6 sm:pb-4 text-center">
                                    {ytvideo}
                                </div>
                                
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default WatchYtVideo